import { Illustration } from "../Illustration.js";
import { useTranslation } from "react-i18next";
import { jsx } from "react/jsx-runtime";

//#region src/components/illustration/variants/AddHomeIllustration.tsx
const AddHomeIllustration = (props) => {
	const { t } = useTranslation("phx-lib");
	return /* @__PURE__ */ jsx(Illustration, {
		...props,
		svgFile: "add-home.svg",
		alt: t("illustration.imageAlt.addHomeIllustration")
	});
};

//#endregion
export { AddHomeIllustration };